<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onCancel()"
        ><ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Edit Caption</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" color="lightmimbo">
  <ion-title class="ion-text-center">Post Caption</ion-title>
  <ion-textarea
    class="italic textarea-padding"
    rows="10"
    autoGrow="true"
    maxlength="250"
    color="lightmimbo"
    placeholder="Write a caption..."
    [(ngModel)]="caption"
  ></ion-textarea>
  <div style="width: 100%; margin-top: 16px; text-align: center">
    <ion-button (click)="updateCaption()"
      ><ion-icon name="save" slot="start"></ion-icon>Update Caption</ion-button
    >
  </div>
</ion-content>
